module.exports = __webpack_public_path__ + "static/media/wine-bottle.f62e635c.svg";